import React from 'react';
import { motion } from 'framer-motion';
import { Code, Coffee, Zap } from 'lucide-react';

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">About Me</h2>
          <div className="title-underline"></div>
        </motion.div>

        <motion.div
          className="about-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div className="about-text" variants={itemVariants}>
            <p className="about-paragraph">
              I'm a passionate 3rd-year Computer Science student at <strong>Institute of Engineering and Management</strong>, specializing in <strong>Backend Development</strong>. 
              With a deep understanding of server-side architecture and scalable system design, I build robust 
              REST APIs and microservices that power modern applications.
            </p>
            <p className="about-paragraph">
              My expertise lies in crafting efficient, maintainable backend solutions using industry-standard 
              technologies and best practices. From database optimization to implementing secure authentication 
              systems, I ensure every line of code contributes to exceptional application performance.
            </p>
            <p className="about-paragraph">
              Currently expanding my knowledge into <strong>Artificial Intelligence and Machine Learning</strong>, 
              exploring how AI can enhance backend systems and create intelligent applications. I'm also deeply 
              invested in <strong>Data Structures and Algorithms</strong>, constantly sharpening my problem-solving 
              skills through competitive programming.
            </p>
          </motion.div>

          <motion.div className="about-highlights" variants={containerVariants}>
            <motion.div className="highlight-card" variants={itemVariants}>
              <div className="highlight-icon">
                <Code size={32} />
              </div>
              <h3>Clean Code</h3>
              <p>Writing maintainable, well-documented code following SOLID principles</p>
            </motion.div>

            <motion.div className="highlight-card" variants={itemVariants}>
              <div className="highlight-icon">
                <Zap size={32} />
              </div>
              <h3>Performance</h3>
              <p>Optimizing queries, implementing caching, and async processing</p>
            </motion.div>

            <motion.div className="highlight-card" variants={itemVariants}>
              <div className="highlight-icon">
                <Coffee size={32} />
              </div>
              <h3>Problem Solver</h3>
              <p>Strong DSA foundation with active LeetCode problem-solving</p>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;